import { ClickAwayListener, Modal } from "@mui/material";
import useModalState from "@src/library/useModalState";
import { useEffect, useMemo, useState } from "react";
import GIcon from "../GIcon";
import DownloadIcon from "./DownloadIcon";
import SpinnerIcon from "@src/icons/SpinnerIcon";

export function ImageMsg({ url, text, file }: { url: string, text: string, file: File | null }) {
    const [open, openModal, closeModal] = useModalState(false)
    const objectUrl = useMemo(() => file ? URL.createObjectURL(file) : url, [file, url])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!file) {
            return
        }

        return () => {
            URL.revokeObjectURL(objectUrl)
        }
    }, [file, objectUrl])

    const handleDownload = (e: React.MouseEvent) => {
        e.stopPropagation()
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }

    return (
        <>
            <Modal open={open} onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disableScrollLock
                style={{
                    zIndex: 3000
                }}
            >
                <div className="flex flex-col justify-center items-center z-3000 m-0 mx-auto max-w-[80dvw] text-center outline-none">
                    <a className="block absolute top-0 left-0 m-4 cursor-pointer bg-secondary-40/50 hover:bg-secondary-40/70 size-8 fill-none stroke-white p-1 rounded-lg" onClick={handleDownload} download={file ? objectUrl : url} href={file ? objectUrl : url}>
                        {loading ? <SpinnerIcon className={'stroke-none fill-white'} /> : <DownloadIcon />}

                    </a>

                    <div className="bg-white p-3 lg:p-8 border border-stone-400 rounded-2xl">
                        <img className="border border-stone-400 border-solid rounded-2xl max-w-[90dvw] max-h-[calc(90dvh-7rem)] object-contain" src={objectUrl} alt={url} />
                        {text}
                    </div>
                </div>
            </Modal>
            <div className="" onClick={() => openModal()}>
                <img src={objectUrl} alt={url} className="max-w-96 max-h-80 object-cover" />
                {text}
            </div>
        </>
    )

}